// This file was auto-generated by Fern from our API Definition.
export const Permission = {
    ViewApplications: "view_applications",
    EditApplication: "edit_application",
    RunService: "run_service",
    ViewWebhooks: "view_webhooks",
    EditWebhooks: "edit_webhooks",
    ViewSecret: "view_secret",
    EditSecret: "edit_secret",
    ViewSpans: "view_spans",
    EditSpans: "edit_spans",
    ViewFolders: "view_folders",
    EditFolders: "edit_folders",
    ViewApiKeys: "view_api_keys",
    EditApiKeys: "edit_api_keys",
    ViewWorkspace: "view_workspace",
    EditWorkspace: "edit_workspace",
    CreateWorkspace: "create_workspace",
    DeleteWorkspace: "delete_workspace",
    ModifyUserRoles: "modify_user_roles",
    AddNewUserToWorkspace: "add_new_user_to_workspace",
    EditOrganization: "edit_organization",
    DeleteOrganization: "delete_organization",
    AddNewUserToOrganization: "add_new_user_to_organization",
    ResetPassword: "reset_password",
    ViewBilling: "view_billing",
    EditBilling: "edit_billing",
    ViewWorkflows: "view_workflows",
    EditWorkflows: "edit_workflows",
    RunWorkflows: "run_workflows",
    ViewEvaluators: "view_evaluators",
    EditEvaluators: "edit_evaluators",
    ViewEnvironments: "view_environments",
    EditEnvironments: "edit_environments",
    DeployEnvironments: "deploy_environments",
    ViewQueries: "view_queries",
    EditQueries: "edit_queries",
    ViewTestsets: "view_testsets",
    EditTestsets: "edit_testsets",
    ViewAnnotations: "view_annotations",
    EditAnnotations: "edit_annotations",
    ViewInvocations: "view_invocations",
    EditInvocations: "edit_invocations",
    ViewEvaluationRuns: "view_evaluation_runs",
    EditEvaluationRuns: "edit_evaluation_runs",
    ViewEvaluationScenarios: "view_evaluation_scenarios",
    EditEvaluationScenarios: "edit_evaluation_scenarios",
    ViewEvaluationResults: "view_evaluation_results",
    EditEvaluationResults: "edit_evaluation_results",
    ViewEvaluationMetrics: "view_evaluation_metrics",
    EditEvaluationMetrics: "edit_evaluation_metrics",
    ViewEvaluationQueues: "view_evaluation_queues",
    EditEvaluationQueues: "edit_evaluation_queues",
    ViewEvents: "view_events",
    ViewTools: "view_tools",
    EditTools: "edit_tools",
    RunTools: "run_tools",
    ViewTriggers: "view_triggers",
    EditTriggers: "edit_triggers",
    RunTriggers: "run_triggers",
    ViewSessions: "view_sessions",
    EditSessions: "edit_sessions",
    RunSessions: "run_sessions",
    ViewMounts: "view_mounts",
    EditMounts: "edit_mounts",
    UseMounts: "use_mounts",
    ViewChannels: "view_channels",
    EditChannels: "edit_channels",
    RunChannels: "run_channels",
    ViewLlmEndpoints: "view_llm_endpoints",
    EditLlmEndpoints: "edit_llm_endpoints",
    UseLlmEndpoints: "use_llm_endpoints",
    ViewMcpEndpoints: "view_mcp_endpoints",
    EditMcpEndpoints: "edit_mcp_endpoints",
    UseMcpEndpoints: "use_mcp_endpoints",
};
